<template>
  <li v-if="isSuperAdmin" class="nav-item store-selector-container d-lg-none">
    <div class="px-2 py-2">
      <label class="text-muted mb-1">選擇 Store</label>
      <v-select
        v-model="selectedStore"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="storeOptions"
        label="name"
        :reduce="(option) => option.id"
        placeholder="選擇 Store"
        class="mobile-store-selector"
        @input="handleStoreChange"
      />
    </div>
  </li>
</template>

<script>
import vSelect from 'vue-select'
import { getUserData } from '@/auth/utils'
import axiosIns from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect,
  },
  
  data() {
    return {
      isSuperAdmin: getUserData().is_admin === true || getUserData().is_admin === 1,
      storeOptions: [],
      selectedStore: getUserData().store_id,
    }
  },
  
  mounted() {
    // 如果是 super admin，獲取所有 Store 列表
    if (this.isSuperAdmin) {
      this.fetchStoreOptions()
    }
  },
  
  methods: {
    // 獲取所有 Store 列表
    fetchStoreOptions() {
      axiosIns.get('/store/list', { params: { is_options: true } })
        .then(response => {
          this.storeOptions = response.data.stores
        })
        .catch(error => {
          console.error('Error fetching store options:', error)
        })
    },
    
    // 處理 Store 變更
    handleStoreChange(storeId) {
      if (storeId) {
        // 更新當前使用者的 store_id
        const userData = getUserData()
        userData.store_id = storeId
        
        // 獲取選中的 Store 資訊
        const selectedStore = this.storeOptions.find(store => store.id === storeId)
        if (selectedStore) {
          userData.store = selectedStore
        }
        
        // 更新 localStorage 中的使用者資訊
        localStorage.setItem('userData', JSON.stringify(userData))
        
        // 顯示成功訊息
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: '成功',
            icon: 'CheckIcon',
            variant: 'success',
            text: `已切換到 ${selectedStore.name}`,
          },
        })
        
        // 重新整理頁面以獲取新 Store 的資料
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    },
  },
}
</script>

<style lang="scss">
.store-selector-container {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  
  .mobile-store-selector {
    width: 100%;
  }
}

.dark-layout {
  .store-selector-container {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
}
</style>
